import { useEffect, useState } from 'react';
import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';

// Lib
import { SOCIAL_PROFILE_EXPORTS } from '@/lib/routes/apiEndpoints';

// Utils
import { post } from '@/utils/client';
import downloadFile from '@/utils/downloadFile';
import { injectEndpointUrlParams } from '@/utils/injectEndpointUrlParams';

const ErrorExportModal = dynamic(() => import('@/components/composite/Modals/ErrorExportModal'));

const ButtonDownloadDirectExport = ({
    isLoading = false,
    currentSocialProfile,
    typeExport,
    requestParams = {},
    sortOptions = [],
    children
}) => {
    const [stateExportXls, setStateExportXls] = useState({
        isLoading,
        error: false
    });

    const generateReport = async () => {
        setStateExportXls({
            isLoading: true,
            error: false
        });
        try {
            let sort_label = undefined;
            const currentFilter =
                sortOptions.filter(
                    (option) =>
                        option?.value === requestParams?.sort?.column &&
                        option?.order === requestParams?.sort?.order
                )?.[0] ??
                sortOptions?.[0] ??
                undefined;
            if (currentFilter) {
                sort_label = currentFilter?.label_selected ?? currentFilter?.label ?? undefined;
            }
            const params = {
                direct_send: true,
                first_page_only: true,
                sort_label,
                ...requestParams
            };
            const endpoint = injectEndpointUrlParams(SOCIAL_PROFILE_EXPORTS, {
                SPID: currentSocialProfile?.id,
                TYPE: typeExport
            });

            const response = await post(endpoint, params);

            if (response?.data) {
                downloadFile(response.data);
                setStateExportXls({
                    isLoading: false,
                    error: false
                });
            } else {
                throw new Error('No download file');
            }
        } catch (e) {
            setStateExportXls({
                isLoading: false,
                error: true
            });
        }
    };

    useEffect(() => {
        setStateExportXls((prevState) => ({
            ...prevState,
            isLoading
        }));
    }, [isLoading]);

    return (
        <>
            {children({
                generateReport,
                isLoading: stateExportXls?.isLoading
            })}
            <ErrorExportModal
                isOpen={stateExportXls?.error}
                toggle={() => {
                    setStateExportXls((prevState) => ({
                        ...prevState,
                        error: false
                    }));
                }}
            />
        </>
    );
};

ButtonDownloadDirectExport.propTypes = {
    currentSocialProfile: PropTypes.object.isRequired,
    typeExport: PropTypes.string.isRequired,
    requestParams: PropTypes.object,
    children: PropTypes.func
};

export default ButtonDownloadDirectExport;
